'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PanelFooter = exports.PanelBody = exports.PanelHeader = exports.Panel = undefined;

var _panel = require('./panel');

var _panel2 = _interopRequireDefault(_panel);

var _panel_header = require('./panel_header');

var _panel_header2 = _interopRequireDefault(_panel_header);

var _panel_body = require('./panel_body');

var _panel_body2 = _interopRequireDefault(_panel_body);

var _panel_footer = require('./panel_footer');

var _panel_footer2 = _interopRequireDefault(_panel_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Panel = _panel2.default;
exports.PanelHeader = _panel_header2.default;
exports.PanelBody = _panel_body2.default;
exports.PanelFooter = _panel_footer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/panel/index.js
// module id = 260
// module chunks = 0